import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram, CreditCard } from 'lucide-react';

const FooterLanding = () => {
  return (
    <footer className="bg-gray-50 text-gray-700 border-t border-gray-200">
      {/* Main Footer Content */}
      <div className="w-full px-6 lg:px-12 py-16">
        <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Column 1: Brand & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/shiftrylogo.png" 
                alt="Shiftry Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-sm leading-relaxed mb-6 text-gray-600">
              The complete workforce management solution for modern businesses. Schedule smarter, track accurately, and optimize your Employee costs with AI-powered intelligence.
            </p>
            
            {/* App Store Buttons */}
            <div className="space-y-3 mb-6">
              <a 
                href="https://play.google.com/store/apps/details?id=com.manocoretechnologies.Shiftry" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block w-40"
              >
                <img 
                  src="/Google_play_button.png" 
                  alt="Get it on Google Play" 
                  className="w-full h-auto hover:opacity-80 transition-opacity"
                />
              </a>
              <a 
                href="https://apps.apple.com/us/app/shiftry-smart-shift-planner/id6748926480?platform=iphone" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block w-40"
              >
                <img 
                  src="/App_store_button.png" 
                  alt="Download on the App Store" 
                  className="w-full h-auto hover:opacity-80 transition-opacity"
                />
              </a>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61577229927397" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/channel/UCtz_ZzOaLIp4cqSNmlZKa_Q" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/manocore-technologies-private-limited/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/shiftry_manocore?igsh=MXJoOTRuZ2tkczQyYg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Column 2: Product */}
          <div>
            <h3 className="text-gray-900 font-bold text-lg mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/schedule-feature" className="hover:text-blue-600 transition-colors text-sm">
                  Schedule Management
                </Link>
              </li>
              <li>
                <Link to="/timesheet-feature" className="hover:text-blue-600 transition-colors text-sm">
                  Time & Attendance
                </Link>
              </li>
              <li>
                <Link to="/analytics-feature" className="hover:text-blue-600 transition-colors text-sm">
                  Analytics & Reports
                </Link>
              </li>
              <li>
                <Link to="/admin-feature" className="hover:text-blue-600 transition-colors text-sm">
                  Admin Dashboard
                </Link>
              </li>
              <li>
                <Link to="/communication-feature" className="hover:text-blue-600 transition-colors text-sm">
                  Team Communication
                </Link>
              </li>
              <li>
                <Link to="/ai-feature" className="hover:text-blue-600 transition-colors text-sm">
                  AI Intelligence
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h3 className="text-gray-900 font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/solutions" className="hover:text-blue-600 transition-colors text-sm">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-blue-600 transition-colors text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-600 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600 transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <Link to="/blog" className="hover:text-blue-600 transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Support */}
          <div>
            <h3 className="text-gray-900 font-bold text-lg mb-4">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="hover:text-blue-600 transition-colors text-sm">
                  Help Center
                </a>
              </li>
              <li>
                <Link to="/documentation" className="hover:text-blue-600 transition-colors text-sm">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-blue-600 transition-colors text-sm">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-blue-600 transition-colors text-sm">
                  Sign Up
                </Link>
              </li>
              <li>
                <Link to="/privacypolicy" className="hover:text-blue-600 transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/tandc" className="hover:text-blue-600 transition-colors text-sm">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5: Contact & Other Products */}
          <div>
            <h3 className="text-gray-900 font-bold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start text-sm">
                <Mail className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <a href="mailto:support@manocore.com" className="hover:text-blue-600 transition-colors">
                  support@manocore.com
                </a>
              </li>
              <li className="flex items-start text-sm">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <span>Chennai, IND</span>
              </li>
            </ul>

            <h4 className="text-gray-900 font-semibold text-sm mb-3">Other Products</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="hover:text-blue-600 transition-colors text-sm">
                  Manocore HR
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-600 transition-colors text-sm">
                  Manocore Books
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors text-sm flex items-center">
                  Mai AI
                  <span className="ml-2 px-2 py-0.5 bg-blue-600 text-white text-xs rounded-full">Beta</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        </div>
      </div>

      {/* Bottom Bar - Copyright, Payment & Branding */}
      <div className="border-t border-gray-200 bg-white">
        <div className="w-full px-6 lg:px-12 py-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              {/* Left: Copyright */}
              <div className="text-sm text-gray-600 text-center md:text-left">
                © {new Date().getFullYear()} Shiftry. All rights reserved.
              </div>
              
              {/* Center: Crafted with Love */}
              <div className="text-center flex items-center gap-2">
                <span className="text-sm text-gray-600">Crafted with</span>
                <span className="text-red-500 text-lg animate-pulse inline-block hover:scale-125 transition-transform">❤️</span>
                <span className="text-sm text-gray-600">by</span>
                <a 
                  href="https://manocore.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-700 font-semibold transition-colors"
                >
                  Manocore Technologies
                </a>
              </div>

              {/* Right: Payment Partner */}
              <div className="flex items-center gap-3">
                <span className="text-xs text-gray-500">Secured by</span>
                <div className="bg-white px-4 py-2 rounded-lg border border-gray-200">
                  <img 
                    src="/Razorpay_logo.svg" 
                    alt="Razorpay" 
                    className="h-5 w-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLanding;
